import React, { useState } from "react";
import { Box, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import style from "../../../src/features/dashboard/dashboard.module.css";

function RangeFields({ setFilters, filters, dateText,searchTerm }) {
  const [fromDate, setFromDate] = useState(
    filters?.fromDate ? dayjs(filters.fromDate) : null
  );
  const [toDate, setToDate] = useState(
    filters?.toDate ? dayjs(filters.toDate) : null
  );

  const handleFromDateChange = (newValue) => {
    const formattedDate = newValue
      ? dayjs(newValue).format("YYYY-MM-DD")
      : null;
    setFromDate(newValue);
    setFilters((prev) => ({ ...prev, fromDate: formattedDate }));

    // Update toDate minDate
    if (toDate && newValue && newValue.isAfter(toDate)) {
      setToDate(null);
      setFilters((prev) => ({ ...prev, toDate: null }));
    }
  };

  const handleToDateChange = (newValue) => {
    const formattedDate = newValue
      ? dayjs(newValue).format("YYYY-MM-DD")
      : null;
    setToDate(newValue);
    setFilters((prev) => ({ ...prev, toDate: formattedDate }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          // width: "100%",
          // height: "100%",
          display: "flex",
          justifyContent: "flex-end",
          position: "relative",
        }}
      >
        <DatePicker
          sx={{ marginRight: "3px!important" }}
          className={style.datePickerStyling}
          format="DD-MM-YYYY"
          label={dateText?.fromDate || "From Date"}
          value={fromDate}
          disableFuture
          onChange={handleFromDateChange}
          renderInput={(params) => <TextField {...params} />}
        />
        <DatePicker
          sx={{ marginRight: "3px!important" }}
          format="DD-MM-YYYY"
          className={style.datePickerStyling}
          label={dateText?.endDate || "To Date"}
          value={toDate}
          disableFuture
          minDate={fromDate} // Disable dates before fromDate
          onChange={handleToDateChange}
          renderInput={(params) => <TextField {...params} />}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default RangeFields;
